/**
 * Facebook Pixel tracking utility
 * Provides methods to track standard and custom events
 *
 * Quem carrega o pixel é a tag do GTM, e ela chega depois do React. Sem a fila
 * abaixo, todo evento disparado na montagem da tela se perdia num aviso no
 * console, que é justamente o ContactPageViewed.
 */

/**
 * Um id por evento. A API de Conversões vai mandar o mesmo evento pelo
 * servidor; sem esse id a Meta conta a conversão duas vezes.
 */
export const novoEventId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

// Quanto tempo esperamos a tag do GTM aparecer antes de desistir do evento.
const ESPERA_MAXIMA_MS = 15000;
const INTERVALO_MS = 300;

const pendentes = [];
let relogio = null;
let esperandoDesde = null;

const enviar = ([metodo, nome, data, eventID]) => {
  window.fbq(metodo, nome, data, { eventID });
  console.log(`FB Pixel${metodo === 'trackCustom' ? ' Custom' : ''}: ${nome}`, data);
};

const drenar = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    while (pendentes.length) enviar(pendentes.shift());
  } else if (Date.now() - esperandoDesde >= ESPERA_MAXIMA_MS) {
    console.warn(`Facebook Pixel not initialized: ${pendentes.length} evento(s) descartado(s)`);
    pendentes.length = 0;
  } else {
    return;
  }
  window.clearInterval(relogio);
  relogio = null;
};

const despachar = (metodo, nome, data, eventID) => {
  if (typeof window === 'undefined') return undefined;
  pendentes.push([metodo, nome, data, eventID]);
  if (window.fbq) {
    drenar();
  } else if (!relogio) {
    esperandoDesde = Date.now();
    relogio = window.setInterval(drenar, INTERVALO_MS);
  }
  return eventID;
};

export const fbPixel = {
  /**
   * Track standard Facebook events
   * @param {string} eventName - Standard event name (e.g., 'Lead', 'CompleteRegistration', 'ViewContent')
   * @param {object} data - Event parameters
   * @param {string} [eventID] - Id do evento; gerado aqui se não vier
   * @returns {string|undefined} o eventID usado, para repetir no envio do servidor
   */
  track: (eventName, data = {}, eventID = novoEventId()) =>
    despachar('track', eventName, data, eventID),

  /**
   * Track custom Facebook events
   * @param {string} eventName - Custom event name
   * @param {object} data - Event parameters
   * @param {string} [eventID] - Id do evento; gerado aqui se não vier
   * @returns {string|undefined} o eventID usado
   */
  trackCustom: (eventName, data = {}, eventID = novoEventId()) =>
    despachar('trackCustom', eventName, data, eventID)
};
